import { render, staticRenderFns } from "./QrPaymentModal.vue?vue&type=template&id=631279ca&scoped=true&"
import script from "./QrPaymentModal.vue?vue&type=script&lang=js&"
export * from "./QrPaymentModal.vue?vue&type=script&lang=js&"
import style0 from "./QrPaymentModal.vue?vue&type=style&index=0&id=631279ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631279ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VImg,VProgressCircular})
